module.exports = __webpack_public_path__ + "img/owlting_logo_big.5781fb24.svg";